import { ButtonProps } from 'primereact/button';
import { IconOptions } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import CertificatesFilledIcon from '../../../../../assets/icons/CertificatesFilled';
import CertificatesOutlineIcon from '../../../../../assets/icons/CertificatesOutline';
import ComponentsFilledIcon from '../../../../../assets/icons/ComponentsFilled';
import ComponentsOutlineIcon from '../../../../../assets/icons/ComponentsOutline';
import ProductsFilledIcon from '../../../../../assets/icons/ProductsFilled';
import ProductsOutlineIcon from '../../../../../assets/icons/ProductsOutline';
import RequestsFilledIcon from '../../../../../assets/icons/RequestsFilled';
import RequestsOutlineIcon from '../../../../../assets/icons/RequestsOutline';
import { useAuth } from '../../../../../hooks/auth/useAuth';
import { AppRoutes } from '../../../../../shared/enums/app-routes';
import MobileHeaderLink from '../header-link/MobileHeaderLink';

const MobileMenuOverlay = () => {
  const { isBasfUser, user } = useAuth();
  const renderFilledIcon = (
    Icon: React.FC<IconOptions<ButtonProps, unknown>>,
    options: IconOptions<ButtonProps, unknown>,
  ) => {
    const newProps = { ...options, fillColor: '#b3cb2d' };

    return <Icon {...newProps} />;
  };

  const { t } = useTranslation();

  return (
    <>
      <MobileHeaderLink
        href={AppRoutes.Products}
        label={t('global.productMenu')}
        icon={ProductsOutlineIcon}
        activeIcon={(options) => {
          return renderFilledIcon(ProductsFilledIcon, options);
        }}
      />
      {!isBasfUser && (
        <MobileHeaderLink
          href={AppRoutes.Components}
          label={t('global.componentsMenu')}
          icon={ComponentsOutlineIcon}
          activeIcon={(options) => {
            return renderFilledIcon(ComponentsFilledIcon, options);
          }}
        />
      )}
      <MobileHeaderLink
        href={AppRoutes.ProductTasksTab}
        label={t('global.tasksMenu')}
        icon={RequestsOutlineIcon}
        activeIcon={(options) => {
          return renderFilledIcon(RequestsFilledIcon, options);
        }}
      />
      {user?.company?.isCertificateManagementEnabled && (
        <MobileHeaderLink
          href={AppRoutes.MyCertificatesTab}
          label={t('global.certificatesMenu')}
          icon={CertificatesOutlineIcon}
          activeIcon={(options) => {
            return renderFilledIcon(CertificatesFilledIcon, options);
          }}
        />
      )}
    </>
  );
};

export default MobileMenuOverlay;
